import { createContext, useContext, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [cart, setCart] = useState({
    productSlug: null,
    quantity: 1,
  });

  const value = useMemo(
    () => ({
      cart,
      setCart,
      setQuantity: (q) =>
        setCart((c) => ({ ...c, quantity: Math.max(1, Math.min(3, q)) })),
      setProduct: (slug) =>
        setCart((c) => ({ ...c, productSlug: slug })),
    }),
    [cart]
  );

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
